/* eslint-disable react/jsx-tag-spacing */ /* for minified SVGs */
import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export type HiddenEyeIconProps = CreateIconComponentProps & {
  title?: string;
  viewBox?: string;
};

export const HiddenEyeIcon: React.FC<HiddenEyeIconProps> = ({
  title = 'HiddenEye',
  viewBox = '0 0 48 48',
  ...props
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M40.608 7.724a1.333 1.333 0 00-1.886 0l-4.558 4.559c-14.61-8.22-27.353 3.195-32.83 11.889 3.377 4.922 6.777 8.433 10.123 10.817L7.61 38.837a1.333 1.333 0 101.885 1.885l4.263-4.263c14.255 8.074 27.208-3.477 32.909-12.287-3.436-4.707-6.854-8.099-10.19-10.431l4.13-4.132c.522-.52.522-1.364 0-1.885zM29.68 16.766A9.292 9.292 0 0024 14.838a9.333 9.333 0 00-9.333 9.334c0 2.137.718 4.107 1.927 5.68l3.869-3.869a4 4 0 015.407-5.406l3.81-3.811zm-2.003 5.773l3.865-3.865a9.291 9.291 0 011.79 5.498A9.333 9.333 0 0124 33.505a9.291 9.291 0 01-5.498-1.79l3.923-3.923a4 4 0 005.253-5.253z"/>
  </CreateIconComponent>
);

export default HiddenEyeIcon;
